import axios, { AxiosError, AxiosResponse } from "axios";

export type body = {
  userToken: String;
  username: String;
  userEmpresa: String;
};

class AccessControl {
  private api = axios.create({
    baseURL: `${process.env.REACT_APP_API_HOST}/accessControl`,
  });

  private microserviceApi = axios.create({
    baseURL: `${process.env.REACT_APP_API_MICROSERVICO}/empresa/accessControl`,
  });

  getAccessByCompany = async (body: body, empresa: string) => {
    try {
      const response = await this.microserviceApi.get<AccessControlResponse>(`/${encodeURIComponent(empresa)}`, {
        headers: {
          userToken: `${body.userToken}`,
          username: `${body.username}`,
          userEmpresa: `${body.userEmpresa}`,
        },
      });
      return response.data;
    } catch (err) {
      throw new Error(getErrorMessage(err, "Erro ao buscar os acessos da empresa"));
    }
  };

  changeAccess = async (body: body, access: ChangeAccessRequest) => {
    try {
      const response = await this.microserviceApi.post("/changeAccess", access, {
        headers: {
          userToken: `${body.userToken}`,
          username: `${body.username}`,
          userEmpresa: `${body.userEmpresa}`,
        },
      });
      return response.data;
    } catch (err) {
      throw new Error(getErrorMessage(err, "Erro ao salvar os acessos da empresa"));
    }
  };

  getAllFunctionalities = async (body: body) => {
    try {
      const data: AxiosResponse = await this.api.post("/getAllFunctionalities", {
        ...body,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (axios.isAxiosError(error)) {
        console.error(error.message);
        console.log("erro --->", error);
        throw new Error(error.message);
        // return error.response?.status;
      }
    }
  };

  getAllByRole = async (body: body, role: string, empresa: string) => {
    try {
      const data: AxiosResponse = await this.api.post("/getAllByRole", {
        ...body,
        role,
        empresa,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (axios.isAxiosError(error)) {
        console.error(error.message);
        console.log("erro --->", error);
        throw new Error(error.message);
        // return error.response?.status;
      }
    }
  };

  changeByRole = async (body: body, role: string, functionalities: string[], empresa: string) => {
    try {
      const data: AxiosResponse = await this.api.post("/changeByRole", {
        ...body,
        role,
        functionalities,
        empresa
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (axios.isAxiosError(error)) {
        console.error(error.message);
        console.log("erro --->", error);
        throw new Error(error.message);
        // return error.response?.status;
      }
    }
  };
  getFullFuncionalities = async (body: body, empresaId: string) => {
    try {
      const data: AxiosResponse = await this.api.post("/getFullFunctionalities", {
        ...body,
        empresaId,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (axios.isAxiosError(error)) {
        console.error(error.message);
        console.log("erro --->", error);
        throw new Error(error.message);
      }
    }
  };
}

export type AccessControlResponse = {
  admFuncs: string[];
  roleFuncs: string[];
};

export type ChangeAccessRequest = AccessControlResponse & {
  empresa: string;
};

function getErrorMessage(error: unknown, fallback: string) {
  if (axios.isAxiosError(error)) {
    return error.response?.data?.message || error.message || fallback;
  }
  return error instanceof Error ? error.message : fallback;
}

export default AccessControl;
